import { Component, OnInit } from "@angular/core";
import { SupportService } from "../../services/support-service";
import { AppService } from "../../services/app.service";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
  selector: "app-auth-header",
  templateUrl: "./auth-header.component.html",
})
export class AuthHeaderComponent implements OnInit {
  countryCode: any = "US";
  stateList: any = [];
  cityList: any = [];
  isOpen = false;
  stateId: any;
  path: any;
  showback = false;
  showHeaderLogin: boolean;
  showPatientHeader = false;
  unsub1: any;
  unsub2: any;
  unsub3: any;
  unsub4: any;
  unsub5: any;

  constructor(
    private router: Router,
    private supportService: SupportService,
    private appService: AppService
  ) {}

  ngOnDestroy() {
    this.unsub1.unsubscribe();
    this.unsub2.unsubscribe();
    this.unsub3.unsubscribe();
    this.unsub4.unsubscribe();
    this.unsub5.unsubscribe();
  }

  patientname: any = "";
  ngOnInit() {
    this.unsub1 = this.supportService.showback.subscribe((res) => {
      if (res) {
        this.showback = res;
      }
    });

    this.unsub2 = this.supportService.countryCode.subscribe((res) => {
      if (res) {
        this.countryCode = res;
        this.getallstatecount();
      }
    });

    this.unsub5 = this.supportService.patientname.subscribe((res) => {
      this.patientname = res;
    });

    this.unsub3 = this.supportService.headerSignBtnHandle.subscribe((res) => {
      this.showHeaderLogin = res;
    });

    this.unsub4 = this.supportService.handlePatientHeader.subscribe((res) => {
      this.showPatientHeader = res;
    });
  }

  passCityName(city) {
    this.supportService.getCityName.next(city);
    document.getElementById("closePopOver").click();
  }

  goToReview() {
    this.router.navigate(["/schedule-review"]);
  }

  getallstatecount() {
    const data = {
      countryCode: this.countryCode,
    };
    this.appService.getallstatecount(data).subscribe((res) => {
      if (
        res &&
        res["status"] &&
        res["status"]["status"] &&
        res["status"]["status"] === 200
      ) {
        this.stateList = res["entity"];
        if (this.stateList && this.stateList.length > 0) {
          this.getallcitycount(this.stateList[0].stateId);
        }
      }
    });
  }

  getallcitycount(stateId) {
    this.stateId = stateId;
    const data = {
      stateId: stateId,
    };

    this.appService.getallcitycount(data).subscribe((res) => {
      if (
        res &&
        res["status"] &&
        res["status"]["status"] &&
        res["status"]["status"] === 200
      ) {
        this.cityList = res["entity"];
      }
    });
  }

  goToSubPage() {
    this.router.navigate(["/subpage"]);
  }

  goToHome() {
    this.router.navigate(["/home"]);
  }

  redirect() {}

  toggleSidemenu() {
    this.supportService.handlePatientHeader.next(true);
  }
}
